import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/example_id_invalid.png'
import _imports_1 from '../assets/images/example_id_valid.png'
import _imports_2 from '../assets/images/example_document_invalid.png'
import _imports_3 from '../assets/images/example_document_valid.png'


const _withScopeId = n => (_pushScopeId("data-v-74b5107c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "formPage"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notification bulmaNotification is-warning mt-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, "There are no applications available for you to start")
], -1))
const _hoisted_3 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_4 = {
  key: 2,
  class: "formPage"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["value"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Which types of identification would you like to apply for?", -1))
const _hoisted_9 = { class: "column" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please provide some basic information about yourself", -1))
const _hoisted_12 = {
  class: "column",
  style: {"padding-top":"2.75rem"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" You are ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" old ")
const _hoisted_16 = { key: 3 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please provide some information about where you were born", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please provide some information about your Social Security status", -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 5 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please provide some information about your mother", -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading mt-6" }, "Please provide some information about your father", -1))
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { key: 4 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading mt-6" }, "Please provide some information about your parents' marital status", -1))
const _hoisted_31 = { key: 6 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please provide some information about your adoption status", -1))
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 7 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please provide some information about your siblings", -1))
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  class: "column",
  style: {"padding-top":"2rem"}
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" This sibling is ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" old ")
const _hoisted_42 = {
  key: 0,
  class: "notification bulmaNotification is-danger mt-4"
}
const _hoisted_43 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_44 = { key: 8 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please provide the location where your Social Security card should be mailed", -1))
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 9 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Do you have any existing ID documents which you can scan or photograph?", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "This will improve the chance of your application being successful.", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("There are two categories of ID: "),
  /*#__PURE__*/_createElementVNode("strong", null, "Primary ID"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("strong", null, "Secondary ID"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoBox" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Primary ID -"),
    /*#__PURE__*/_createTextVNode(" If you have any of these, you only need to supply "),
    /*#__PURE__*/_createElementVNode("strong", null, "one"),
    /*#__PURE__*/_createTextVNode(":")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Current state-issued driver's license"),
    /*#__PURE__*/_createElementVNode("li", null, "Current state-issued photo ID card"),
    /*#__PURE__*/_createElementVNode("li", null, "Current passport or visa")
  ])
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoBox" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Secondary ID -"),
    /*#__PURE__*/_createTextVNode(" If you only have secondary ID, you will need to supply "),
    /*#__PURE__*/_createElementVNode("strong", null, "2-3"),
    /*#__PURE__*/_createTextVNode(" of these:")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Social Security Card"),
    /*#__PURE__*/_createElementVNode("li", null, "Medicaid/Medicare Card"),
    /*#__PURE__*/_createElementVNode("li", null, "Current U.S. military ID"),
    /*#__PURE__*/_createElementVNode("li", null, "Current Department of Corrections photo ID card"),
    /*#__PURE__*/_createElementVNode("li", null, "Current student ID card"),
    /*#__PURE__*/_createElementVNode("li", null, "Veteran's ID"),
    /*#__PURE__*/_createElementVNode("li", null, "Voter ID"),
    /*#__PURE__*/_createElementVNode("li", null, "Temporary driver's license"),
    /*#__PURE__*/_createElementVNode("li", null, "Car registration or title with current address"),
    /*#__PURE__*/_createElementVNode("li", null, "Recent Bank statement with current address"),
    /*#__PURE__*/_createElementVNode("li", null, "Recent Pay stub with current address"),
    /*#__PURE__*/_createElementVNode("li", null, "Income tax return / W-2 form showing current address"),
    /*#__PURE__*/_createElementVNode("li", null, "Letter from government agency dated within the last six months, showing current address")
  ])
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = {
  key: 0,
  class: "notification bulmaNotification is-warning mt-4"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "If you don't have any existing ID, we will still do our best to process your request.", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "However, your chance of success is increased if you are able to provide some kind of documentation to support your application.", -1))
const _hoisted_62 = [
  _hoisted_59,
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = { key: 10 }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please upload photos / scans of any existing ID documents you have available", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("When taking photos, "),
  /*#__PURE__*/_createElementVNode("strong", null, "please ensure the image is clear, and frame the photo tightly around your ID")
], -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "exampleImageRow mt-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "exampleImage",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "exampleImage",
    src: _imports_1
  })
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "exampleImageRow mb-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "exampleImage",
    src: _imports_2
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "exampleImage",
    src: _imports_3
  })
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Upload your photos below:")
], -1))
const _hoisted_69 = {
  key: 0,
  class: "notification bulmaNotification is-warning mt-6"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "If you only have secondary ID, you should upload 2 or more documents for the best chance of success in your application", -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { key: 11 }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Your vote matters", -1))
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 12 }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please let us know if you agree to us verifying your identity", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Do we have your permission to verify your identity with Equifax?", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "This will require us to share some of your information with them.", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Verifying your identity may allow us to speed up your application, and improve the chance of a successful result.")
], -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "However, you may opt-out if you'd prefer.", -1))
const _hoisted_83 = { key: 13 }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please let us know how we should keep you up-to-date about your application", -1))
const _hoisted_85 = {
  key: 2,
  class: "notification bulmaNotification is-warning mt-4"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "If you don't provide any contact information, you will need to speak to your caseworker for updates on your application", -1))
const _hoisted_87 = [
  _hoisted_86
]
const _hoisted_88 = { key: 14 }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "pageHeading",
  style: {"text-align":"center"}
}, "Ok! We're ready to submit your application", -1))
const _hoisted_90 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_91 = { key: 15 }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Congratulations! Your application has been submitted", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "You can return to the home page to view your applications.", -1))
const _hoisted_94 = {
  key: 0,
  class: "notification bulmaNotification is-warning mt-4"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "A required form must be signed and attached to your application.", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please work with your caseworker now to complete this form to avoid processing delays.", -1))
const _hoisted_97 = [
  _hoisted_95,
  _hoisted_96
]
const _hoisted_98 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_99 = {
  key: 16,
  class: "notification bulmaNotification is-danger mt-4"
}
const _hoisted_100 = {
  key: 17,
  class: "is-flex is-flex-direction-row mt-6"
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-flex-grow-1" }, null, -1))

import { 
    moduleState, initNewApplication, submitModule,
    initBirthRecordFormData, initSocialSecurityFormData,
    sections, type Page,
    districts, siblingStates, IdTypeOptions, EquifaxConsentOptions, YesNo
} from './module';

import { BirthRecords, Core, Feature, Identification, ProfileTypes, SocialSecurity } from '@minicity/core';
import { isModuleEnabled, sessionState } from '@/core/session';
import { uploadFile } from '@/core/api';

import LoadingSpinner from '@/components/LoadingSpinner.vue';
import LoadingPage from '@/components/LoadingPage.vue';
  
import { useForm, Form, PageSpecs } from '@/composables/useForm';
import { Validations } from '@/composables/useValidation';

import { computed, onMounted, onUnmounted, ref } from 'vue';
import { createDraftApplication, getDraftApplication, updateDraftApplicationContent } from '../api';
import { DeepPartial, formatAge, mapHttpError, notifyError } from '@/core/utils';
import { notifyNetworkError } from '@/core/utils';
import { getApplicationStatus } from '@/features/applicationStatus/api';

import { InteractionType, logFeatureInteraction } from '@/features/analytics/api';

import ListEditor from '@/components/ListEditor.vue';
import { useEditableList } from '@/composables/useEditableList';


export default /*#__PURE__*/_defineComponent({
  __name: 'IdentificationApplicationForm',
  setup(__props) {

const draftId = ref<string|null>(null);

/*
 * Define any special logic for each page
 */
const pages: PageSpecs<Page> = {
    "selectApplicationTypes": {
        validate: ()=>{
            const appl = moduleState.value!.application!;
            const enabledApplications = moduleState.value!.miscState.enabledApplications;

            if (!enabledApplications.birthRecords && !enabledApplications.socialSecurity) {
                return ["Please select which types of ID you wish to apply for"];
            }

            // Initialize application data
            // (and avoid destroying any existing data if the user had previously entered stuff and navigated back to this page)
            if (enabledApplications.birthRecords) {
                appl.birthRecords = appl.birthRecords || initBirthRecordFormData();
            } else {
                appl.birthRecords = undefined;
            }

            if (enabledApplications.socialSecurity) {
                appl.socialSecurity = appl.socialSecurity || initSocialSecurityFormData();
            } else {
                appl.socialSecurity = undefined;
            }
        },
        nextPage: "basicCitizenInfo",
    },
    "basicCitizenInfo": {
        validate: ()=>{
            const appl = moduleState.value!.application!;
            if (appl.firstName!.length == 0) return ["Please enter your first name"];
            if (appl.lastName!.length == 0) return ["Please enter your last name"];
            if (!appl.dateOfBirth) return ["Please select your date of birth"];

            if (appl.socialSecurity) {
                if (!appl.socialSecurity.sex) return ["Please select your sex / gender"];
            }
        },
        nextPage: "socialSecurity"
    },
    "socialSecurity": {
        enabled: () => moduleState.value?.application.socialSecurity != undefined,
        validate: ()=>{
            const appl = moduleState.value!.application!;

            if (!appl.socialSecurity!.previouslyAppliedForCard) return ["Please indicate whether you've previously applied for a Social Security card"];

            if (appl.socialSecurity!.previousSocialSecurityNumber!.length != 0 && appl.socialSecurity!.previousSocialSecurityNumber!.length != 9)
                return ["Social Security Number should be in the form AAABBCCCC. Leave blank if not known"];

            if (!appl.socialSecurity!.citizenship) return ["Please select your citizenship status"];

        },
        nextPage: "birthPlace"
    },
    "birthPlace": {
        validate: ()=>{
            const appl = moduleState.value!.application!;
            if (appl.birthCity!.length == 0) return ["Please enter the city where you were born"];
            if (appl.birthState == null) return ["Please select the state where you were born"];

            if (appl.birthRecords) {
                if (appl.birthRecords.birthHospital!.length == 0) return ["Please select the hospital where you were born"];
                
                if (districts[appl.birthState]) {
                    if (!appl.birthRecords.birthDistrict || !districts[appl.birthState]!.includes(appl.birthRecords.birthDistrict)) return ["Please select the district where you were born"];
                } else {
                    appl.birthRecords.birthDistrict = ProfileTypes.BirthDistrict['N/A'];
                }
            }
        },
        nextPage: "parents"
    },
    "parents": {
        validate: ()=>{
            const appl = moduleState.value!.application!;

            if (appl.fatherName?.length == 0) { appl.fatherName = "Unknown Unknown"; }
            if (appl.motherName?.length == 0) { appl.motherName = "Unknown Unknown"; }

            if (appl.birthRecords) {
                if (appl.fatherMaidenName?.length == 0) { appl.fatherMaidenName = "Unknown"; }
                if (appl.motherMaidenName?.length == 0) { appl.motherMaidenName = "Unknown"; }

                if (!appl.birthRecords.parentsMaritalStatus) return ["Please indicate whether you parents were married when you were born"];

                if (appl.socialSecurity) {
                    if (appl.socialSecurity!.motherSocialSecurityNumber!.length != 0 && appl.socialSecurity!.motherSocialSecurityNumber!.length != 9)
                        return ["Mother's Social Security Number should be in the form AAABBCCCC. Leave blank if not known"];

                    if (appl.socialSecurity!.fatherSocialSecurityNumber!.length != 0 && appl.socialSecurity!.fatherSocialSecurityNumber!.length != 9)
                        return ["Father's Social Security Number should be in the form AAABBCCCC. Leave blank if not known"];
                }
            }
        },
        nextPage: "adoption"
    },
    "adoption": {
        enabled: () => moduleState.value?.application.birthRecords != undefined,
        validate: ()=>{
            const appl = moduleState.value!.application!;
            if (!appl.birthRecords!.adoptionStatus) return ["Please indicate whether or not you were adopted"];

            if (appl.birthRecords!.adoptionStatus == ProfileTypes.YesNoUnknown.Yes) {
                if (!appl.birthRecords!.adoptionRequestType || appl.birthRecords!.adoptionRequestType == ProfileTypes.AdoptionRequestType['N/A'])
                    return ["Please indicate whether you want a certificate with your name prior to, or after adoption"];
            } else {
                appl.birthRecords!.adoptionRequestType = ProfileTypes.AdoptionRequestType['N/A'];
            }
        },
        nextPage: "siblings",
    },
    "siblings": {
        enabled: () => moduleState.value?.application.birthRecords != undefined && siblingStates.includes(moduleState.value.application.birthState!),
        onLoad: () => {
            if (!moduleState.value!.application.birthRecords!.siblings) {
                moduleState.value!.application.birthRecords!.siblings = [];
            }
        },
        nextPage: "mailing"
    },
    "mailing": {
        enabled: () => false, //moduleState.value?.application.socialSecurity != undefined,
        onLoad: () => {
            const appl = moduleState.value!.application!;
            if (!appl.socialSecurity!.mailingAddress) {
                appl.socialSecurity!.mailingAddress = {
                    number: "",
                    street: "",
                    city: appl.birthCity,
                    state: appl.birthState! as unknown as ProfileTypes.State,
                    postalCode: ""
                };
            }
        },
        validate: ()=>{
            const appl = moduleState.value!.application!;
            
            if (appl.socialSecurity!.useCareProviderAddressForMailing) {
                appl.socialSecurity!.mailingAddress = undefined;
            } else {
                if (appl.socialSecurity!.mailingAddress!.number!.length == 0) return ["Please enter your house / building number"];
                if (appl.socialSecurity!.mailingAddress!.street!.length == 0) return ["Please enter your street name"];
                if (appl.socialSecurity!.mailingAddress!.city!.length == 0) return ["Please enter your city"];
                if (appl.socialSecurity!.mailingAddress!.postalCode!.length == 0) return ["Please enter your zip code"];
                if (!appl.socialSecurity!.mailingAddress!.state) return ["Please select your state"];
            }
        },
        nextPage: "idType"
    },
    "idType": {
        validate: ()=>{
            const appl = moduleState.value!.application!;
            if (!moduleState.value!.miscState.idType.possessedIdType) return ["Please indicate which type of ID you have"];

            if (appl.birthRecords) {
                switch (moduleState.value!.miscState.idType.possessedIdType as IdTypeOptions) {
                    case IdTypeOptions['Primary ID']:          appl.birthRecords.possessedIdTypes = ProfileTypes.PossessedIdTypes.Primary;   break;
                    case IdTypeOptions['Secondary ID']:        appl.birthRecords.possessedIdTypes = ProfileTypes.PossessedIdTypes.Secondary; break;
                    case IdTypeOptions["I don't have any ID"]: appl.birthRecords.possessedIdTypes = ProfileTypes.PossessedIdTypes.None;      break;
                }
            }
        },
        nextPage: "supportDocUpload"
    },
    "supportDocUpload": {
        enabled: () => moduleState.value!.miscState.idType.possessedIdType != IdTypeOptions["I don't have any ID"],
        validate: ()=>{
            if (moduleState.value!.supportDocuments.length < 1) return ["Please upload at least one document. If you don't have any, hit 'Back'"];
        },
        nextPage: "votingIntent"
    },
    "votingIntent": {
        enabled: () => moduleState.value?.application.birthRecords != undefined,
        validate: ()=>{
            if (!moduleState.value!.application.birthRecords!.votingIntent)
                return ["Please indicate whether you intend to use your ID to vote in the next election"];
        },
        nextPage: "equifaxConsent"
    },
    "equifaxConsent": {
        enabled: () => isModuleEnabled(Feature.Type.EQUIFAX_CHECKS) && moduleState.value?.application.socialSecurity != undefined,
        onLoad: () => {
            const appl = moduleState.value!.application!;
            if (moduleState.value!.miscState.equifaxConsent.consent == null) {
                if (appl.socialSecurity?.equifaxConsent === true) {
                moduleState.value!.miscState.equifaxConsent.consent = EquifaxConsentOptions['Yes, my data can be shared'];
                } else if (appl.socialSecurity?.equifaxConsent === false) {
                    moduleState.value!.miscState.equifaxConsent.consent = EquifaxConsentOptions['No, do not share my data'];
                }
            }
        },
        validate: ()=>{
            const appl = moduleState.value!.application!;
            if (moduleState.value!.miscState.equifaxConsent.consent == null) return ["Please indicate whether you agree to us verifying your identity"];

            appl.socialSecurity!.equifaxConsent = moduleState.value!.miscState.equifaxConsent.consent == EquifaxConsentOptions['Yes, my data can be shared'];
        },
        nextPage: "notificationPreferences"
    },
    "notificationPreferences": {
        validate: ()=>{
            const prefs = moduleState.value!.notificationPreferences!;
            const pageState = moduleState.value!.miscState.notificationPreferences;

            if (pageState.noneEnabled) {
                prefs.email = undefined;
                prefs.sms = undefined;
            } else {
                if (!pageState.emailEnabled && !pageState.smsEnabled) return ["Please indicate how you would like to receive updates about your application"];

                if (pageState.emailEnabled) {
                    if (!Validations.email(prefs.email)) return ["Please enter a valid email address"];
                } else {
                    prefs.email = undefined;
                }

                if (pageState.smsEnabled) {
                    if (!Validations.phone_US(prefs.sms)) return ["Please enter a valid US phone number"];
                } else {
                    prefs.sms = undefined;
                }
            }
        },
        nextPage: "preSubmit"
    },
    "preSubmit": {},
    "completed": {disallowBack: true},
};


/*
 * Initialize
 */
let availableApplicationTypes: string[] = [];

 onMounted(() => {
    if (!sessionState.session) return;
    
    getApplicationStatus(sessionState.session.user.id)
    .then(applStatus => {
        // Determine which application types are available
        // The module must be enabled for the citizen's care provider, and they must not already have an application in-progress
        if (isModuleEnabled('BIRTH_RECORDS') && !applStatus.applications.find(appl => appl.applicationType == 'birthRecords')) {
            availableApplicationTypes.push('birthRecords');
        }

        if (isModuleEnabled('SOCIAL_SECURITY') && !applStatus.applications.find(appl => appl.applicationType == 'socialSecurity')) {
            if (!isModuleEnabled('ONLINE_SOCIAL_SECURITY_APPLICATION')) {
                availableApplicationTypes.push('socialSecurity');
            }
        }
        
        // Load or start a new application
        getDraftApplication(sessionState.session!.user.id, "identification")
        .then(draft => {
            console.log(`Resumed draft application ${draft.id}`);

            moduleState.value = JSON.parse(draft.content);
            draftId.value = draft.id;
            initFormNavigation();
        })
        .catch(err => {
            console.error("Failed to resume application", err);
            startNewApplication();
        });
    });
});

const startNewApplication = () => {
    console.log("Starting new application");

    moduleState.value = initNewApplication({
        // Initial misc state
        enabledApplications: {
            birthRecords: false,
            socialSecurity: false,
        },
        equifaxConsent: {
            consent: null,
        },
        idType: {
            possessedIdType: null
        },
        notificationPreferences: {
            emailEnabled: sessionState.session!.user.preferences.notifications.email != undefined,
            smsEnabled: sessionState.session!.user.preferences.notifications.sms != undefined,
            noneEnabled: false,
        },
        completed: {
            notarizationRequired: false,
        }
    });

    createDraftApplication(sessionState.session!.user.id, "identification", moduleState.value)
    .then(createdDraftId => {
        draftId.value = createdDraftId;
        initFormNavigation();
    })
    .catch(err => notifyError(err))
}

let formUpdateTimer: NodeJS.Timeout|null = null; 

const initFormNavigation = () => {
    form.value = useForm(pages, sections, moduleState.value!.formNavState, onFormChanged);

    // The set of available applications may have changed - detect and handle that by bouncing the user back to the application-type-selection screen
    let resetForm = false;
    if (moduleState.value!.application.birthRecords && !availableApplicationTypes.includes('birthRecords')) {
        moduleState.value!.application.birthRecords = undefined;
        moduleState.value!.miscState.enabledApplications.birthRecords = false;
        resetForm = true;
    }
    if (moduleState.value!.application.socialSecurity && !availableApplicationTypes.includes('socialSecurity')) {
        moduleState.value!.application.socialSecurity = undefined;
        moduleState.value!.miscState.enabledApplications.socialSecurity = false;
        resetForm = true;
    }

    if (resetForm) {
        console.log("Resetting form due to change in available application types");
        form.value.displayPage("selectApplicationTypes", true);
    }

    // Set a timer to regularly push updated form state to server (also keeps session alive)
    const updateTimer = () => {
        console.log("Update timer triggered");
        onFormChanged();
        formUpdateTimer = setTimeout(updateTimer, 30000);
    };
    formUpdateTimer = setTimeout(updateTimer, 30000);

    // Generate analytics event
    logFeatureInteraction("applications/identification", "IDENTIFICATION", InteractionType.CLICK, JSON.stringify({'draftId': draftId.value, 'page': form.value!.state.activePage, 'errors': form.value!.state.errors}));
}

onUnmounted(() => {
    if (formUpdateTimer) {
        console.log("Diabled update timer", formUpdateTimer);
        clearTimeout(formUpdateTimer);
    }
});

/*
 * Form state
 */
const form = ref<Form<Page>|null>(null);

const currentSection = computed(() => {
    if (!moduleState.value) return null;
    return form.value!.determineCurrentSection();
});

/*
 * List editors
 */
 const siblings = ref(useEditableList<ProfileTypes.Sibling>(
    () => moduleState.value!.application.birthRecords!.siblings! as DeepPartial<ProfileTypes.Sibling>[], // Items
    () => { return {} }, // Create new item

    // Validate
    (item: DeepPartial<ProfileTypes.Sibling>) => {
        if (item.name!.length == 0) return ["Please enter full name name"];
        if (!item.dateOfBirth) return ["Please enter date of birth"];
        return [];
    },

    // On change
    () => onFormChanged()
));


/*
 * Document uploads
 */
const deleteSupportDocument = (doc: Core.Document) => {
    moduleState.value!.supportDocuments = moduleState.value!.supportDocuments.filter(d => d.id != doc.id);
    onFormChanged();
};
  
const uploadSupportDocument = (uploadInfo: {file: File, onDone: ()=>any}) => {
    uploadFile(uploadInfo.file, ['IMAGE','PDF'])
    .then(doc => {
        moduleState.value!.supportDocuments.push(doc);
        moduleState.value!.formNavState.errors = [];
        onFormChanged();
    })
    .catch(err => notifyNetworkError("Failed to upload document", err))
    .finally(() => uploadInfo.onDone());
}


/*
 * Draft saving / form submission
 */
let lastPushedModuleStateJson = "";
const onFormChanged = () => {
    const moduleStateJson = JSON.stringify(moduleState.value);
    if (moduleStateJson == lastPushedModuleStateJson) return; // No change - no need to update

    console.log("Pushing updated form state to server", moduleState.value);

    updateDraftApplicationContent(sessionState.session!.user.id, draftId.value!, moduleState.value)
    .then(() => lastPushedModuleStateJson = moduleStateJson);

    // Generate analytics event
    logFeatureInteraction("applications/identification", "IDENTIFICATION", InteractionType.PROGRESS, JSON.stringify({'draftId': draftId.value, 'page': form.value!.state.activePage, 'errors': form.value!.state.errors}));
};

const submissionInProgress = ref<boolean>(false);

const submitApplication = async () => {
    form.value!.state.errors = [];
    console.log("Submitting", moduleState.value!.application);

    submissionInProgress.value = true;
    try {
        const result = await submitModule(draftId.value!);
        moduleState.value!.miscState.completed.notarizationRequired = result.notarizationRequired;

        form.value!.displayPage("completed");

        // Generate analytics event
        logFeatureInteraction("applications/identification/submit", "IDENTIFICATION", InteractionType.COMPLETION, JSON.stringify({'draftId': draftId.value, 'page': form.value!.state.activePage}));
    } catch (ex) {
        console.log(ex);
        form.value!.state.errors = [`Failed to submit - ${mapHttpError(ex)}`];

        // Generate analytics event
        logFeatureInteraction("applications/identification/submit", "IDENTIFICATION", InteractionType.ERROR, JSON.stringify({'draftId': draftId.value, 'errors': form.value!.state.errors}));
    } finally {
        submissionInProgress.value = false;
    }
};


return (_ctx: any,_cache: any) => {
  const _component_SaveButton = _resolveComponent("SaveButton")!
  const _component_FormCheckboxField = _resolveComponent("FormCheckboxField")!
  const _component_Columns = _resolveComponent("Columns")!
  const _component_FormTextField = _resolveComponent("FormTextField")!
  const _component_FormSelectField = _resolveComponent("FormSelectField")!
  const _component_HalfColumn = _resolveComponent("HalfColumn")!
  const _component_FormDateField = _resolveComponent("FormDateField")!
  const _component_FormRadioGroupField = _resolveComponent("FormRadioGroupField")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!
  const _component_DocumentUploadWidget = _resolveComponent("DocumentUploadWidget")!
  const _component_AppPageFrame = _resolveComponent("AppPageFrame")!

  return (_openBlock(), _createBlock(_component_AppPageFrame, {
    showHeader: "",
    login: "require"
  }, {
    default: _withCtx(() => [
      (!form.value || !_unref(moduleState) || !draftId.value)
        ? (_openBlock(), _createBlock(LoadingPage, { key: 0 }))
        : (_unref(availableApplicationTypes).length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_SaveButton, {
                  large: "",
                  label: "Return To Home Page",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_unref(currentSection))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("h1", null, _toDisplayString(_unref(currentSection)?.name), 1),
                    (_unref(currentSection) != null)
                      ? (_openBlock(), _createElementBlock("progress", {
                          key: 0,
                          class: "progress is-primary mt-5",
                          value: 5 + _unref(currentSection).progress * 90,
                          max: "100"
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'selectApplicationTypes')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_Columns, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          (_unref(isModuleEnabled)('BIRTH_RECORDS'))
                            ? (_openBlock(), _createBlock(_component_FormCheckboxField, {
                                key: 0,
                                isDisabled: !_unref(availableApplicationTypes).includes('birthRecords'),
                                boxLabel: _unref(availableApplicationTypes).includes('birthRecords') ? 'Birth Records' : 'Birth Records (already applied)',
                                modelValue: _unref(moduleState).miscState.enabledApplications.birthRecords,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(moduleState).miscState.enabledApplications.birthRecords) = $event))
                              }, null, 8, ["isDisabled", "boxLabel", "modelValue"]))
                            : _createCommentVNode("", true),
                          (_unref(isModuleEnabled)('SOCIAL_SECURITY') && !_unref(isModuleEnabled)(_unref(Feature).Type.ONLINE_SOCIAL_SECURITY_APPLICATIONS))
                            ? (_openBlock(), _createBlock(_component_FormCheckboxField, {
                                key: 1,
                                isDisabled: !_unref(availableApplicationTypes).includes('socialSecurity'),
                                boxLabel: _unref(availableApplicationTypes).includes('socialSecurity') ? 'Social Security' : 'Social Security (already applied)',
                                modelValue: _unref(moduleState).miscState.enabledApplications.socialSecurity,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(moduleState).miscState.enabledApplications.socialSecurity) = $event))
                              }, null, 8, ["isDisabled", "boxLabel", "modelValue"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'basicCitizenInfo')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_Columns, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_FormTextField, {
                          label: "First Name *",
                          modelValue: _unref(moduleState).application.firstName,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(moduleState).application.firstName) = $event)),
                          trimmed: "",
                          autoFocus: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormTextField, {
                          label: "Middle Name",
                          modelValue: _unref(moduleState).application.middleName,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(moduleState).application.middleName) = $event)),
                          trimmed: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormTextField, {
                          label: "Last Name *",
                          modelValue: _unref(moduleState).application.lastName,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(moduleState).application.lastName) = $event)),
                          trimmed: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_unref(moduleState).application.socialSecurity)
                      ? (_openBlock(), _createBlock(_component_HalfColumn, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FormSelectField, {
                              label: "Your Sex / Gender *",
                              options: _unref(ProfileTypes).Sex,
                              allowNullSelection: "",
                              modelValue: _unref(moduleState).application.socialSecurity.sex,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(moduleState).application.socialSecurity.sex) = $event))
                            }, null, 8, ["options", "modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_Columns, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_FormDateField, {
                          label: "Date Of Birth *",
                          modelValue: _unref(moduleState).application.dateOfBirth,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(moduleState).application.dateOfBirth) = $event)),
                          past: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_12, [
                          (_unref(moduleState).application.dateOfBirth)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                _hoisted_14,
                                _createElementVNode("strong", null, _toDisplayString(_unref(formatAge)(_unref(moduleState).application.dateOfBirth)), 1),
                                _hoisted_15
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'birthPlace')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_Columns, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_FormTextField, {
                          label: "Birth City *",
                          modelValue: _unref(moduleState).application.birthCity,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(moduleState).application.birthCity) = $event)),
                          trimmed: "",
                          autoFocus: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormSelectField, {
                          label: "Birth State *",
                          options: _unref(ProfileTypes).StateNotUnknown,
                          allowNullSelection: "",
                          modelValue: _unref(moduleState).application.birthState,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(moduleState).application.birthState) = $event))
                        }, null, 8, ["options", "modelValue"])
                      ]),
                      _: 1
                    }),
                    (_unref(moduleState).application.birthRecords)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_Columns, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_FormTextField, {
                                label: "Birth Hospital *",
                                modelValue: _unref(moduleState).application.birthRecords.birthHospital,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(moduleState).application.birthRecords.birthHospital) = $event)),
                                trimmed: ""
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_FormTextField, {
                                label: "Birth County",
                                modelValue: _unref(moduleState).application.birthRecords.birthCounty,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(moduleState).application.birthRecords.birthCounty) = $event)),
                                trimmed: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          (_unref(moduleState).application.birthState! in _unref(districts))
                            ? (_openBlock(), _createBlock(_component_FormSelectField, {
                                key: 0,
                                label: "Birth District *",
                                options: _unref(ProfileTypes).BirthDistrict,
                                includedOptions: _unref(districts)[_unref(moduleState).application.birthState!],
                                allowNullSelection: "",
                                modelValue: _unref(moduleState).application.birthRecords.birthDistrict,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(moduleState).application.birthRecords.birthDistrict) = $event))
                              }, null, 8, ["options", "includedOptions", "modelValue"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'socialSecurity')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    (_unref(moduleState).application.socialSecurity)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createVNode(_component_Columns, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Have you ever applied for a Social Security card before? *",
                                options: _unref(ProfileTypes).YesNoUnknown,
                                modelValue: _unref(moduleState).application.socialSecurity.previouslyAppliedForCard,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(moduleState).application.socialSecurity.previouslyAppliedForCard) = $event))
                              }, null, 8, ["options", "modelValue"]),
                              _createVNode(_component_FormTextField, {
                                label: "Your Social Security Number (if known)",
                                modelValue: _unref(moduleState).application.socialSecurity.previousSocialSecurityNumber,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(moduleState).application.socialSecurity.previousSocialSecurityNumber) = $event)),
                                trimmed: "",
                                length: 9,
                                isPassword: "",
                                noAutoFill: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_HalfColumn, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_FormRadioGroupField, {
                                label: "What is your citizenship status? *",
                                options: _unref(SocialSecurity).Citizenship,
                                modelValue: _unref(moduleState).application.socialSecurity.citizenship,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(moduleState).application.socialSecurity.citizenship) = $event)),
                                stacked: ""
                              }, null, 8, ["options", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'parents')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode(_component_Columns, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_FormTextField, {
                          label: "Birth Mother's Full Name",
                          modelValue: _unref(moduleState).application.motherName,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(moduleState).application.motherName) = $event)),
                          trimmed: "",
                          autoFocus: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormTextField, {
                          label: "Mother's Surname Before Marriage",
                          modelValue: _unref(moduleState).application.motherMaidenName,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(moduleState).application.motherMaidenName) = $event)),
                          trimmed: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_unref(moduleState).application.birthRecords)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createVNode(_component_Columns, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_FormTextField, {
                                label: "Mother's Birth City",
                                modelValue: _unref(moduleState).application.birthRecords.motherBirthCity,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(moduleState).application.birthRecords.motherBirthCity) = $event)),
                                trimmed: ""
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_FormSelectField, {
                                label: "Mother's Birth State",
                                options: _unref(ProfileTypes).State,
                                modelValue: _unref(moduleState).application.birthRecords.motherBirthState,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(moduleState).application.birthRecords.motherBirthState) = $event))
                              }, null, 8, ["options", "modelValue"]),
                              _createVNode(_component_FormTextField, {
                                label: "Mother's Birth County",
                                modelValue: _unref(moduleState).application.birthRecords.motherBirthCounty,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(moduleState).application.birthRecords.motherBirthCounty) = $event)),
                                trimmed: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(moduleState).application.socialSecurity)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createVNode(_component_HalfColumn, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_FormTextField, {
                                label: "Mother's Social Security Number",
                                modelValue: _unref(moduleState).application.socialSecurity.motherSocialSecurityNumber,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(moduleState).application.socialSecurity.motherSocialSecurityNumber) = $event)),
                                trimmed: "",
                                length: 9,
                                isPassword: "",
                                noAutoFill: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_26,
                    _createVNode(_component_Columns, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_FormTextField, {
                          label: "Birth Father's Full Name",
                          modelValue: _unref(moduleState).application.fatherName,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(moduleState).application.fatherName) = $event)),
                          trimmed: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormTextField, {
                          label: "Father's Surname Before Marriage",
                          modelValue: _unref(moduleState).application.fatherMaidenName,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(moduleState).application.fatherMaidenName) = $event)),
                          trimmed: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_unref(moduleState).application.birthRecords)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createVNode(_component_Columns, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_FormTextField, {
                                label: "Father's Birth City",
                                modelValue: _unref(moduleState).application.birthRecords.fatherBirthCity,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(moduleState).application.birthRecords.fatherBirthCity) = $event)),
                                trimmed: ""
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_FormSelectField, {
                                label: "Father's Birth State",
                                options: _unref(ProfileTypes).State,
                                modelValue: _unref(moduleState).application.birthRecords.fatherBirthState,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(moduleState).application.birthRecords.fatherBirthState) = $event))
                              }, null, 8, ["options", "modelValue"]),
                              _createVNode(_component_FormTextField, {
                                label: "Father's Birth County",
                                modelValue: _unref(moduleState).application.birthRecords.fatherBirthCounty,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(moduleState).application.birthRecords.fatherBirthCounty) = $event)),
                                trimmed: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(moduleState).application.socialSecurity)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createVNode(_component_HalfColumn, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_FormTextField, {
                                label: "Father's Social Security Number",
                                modelValue: _unref(moduleState).application.socialSecurity.fatherSocialSecurityNumber,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(moduleState).application.socialSecurity.fatherSocialSecurityNumber) = $event)),
                                trimmed: "",
                                length: 9,
                                isPassword: "",
                                noAutoFill: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(moduleState).application.birthRecords)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _hoisted_30,
                          _createVNode(_component_FormRadioGroupField, {
                            label: "Were Your Parents Married When You Were Born? *",
                            options: _unref(ProfileTypes).YesNoUnknown,
                            modelValue: _unref(moduleState).application.birthRecords.parentsMaritalStatus,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(moduleState).application.birthRecords.parentsMaritalStatus) = $event))
                          }, null, 8, ["options", "modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'adoption')
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _hoisted_32,
                    (_unref(moduleState).application.birthRecords)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createVNode(_component_FormRadioGroupField, {
                            label: "Were You Adopted? *",
                            options: _unref(ProfileTypes).YesNoUnknown,
                            modelValue: _unref(moduleState).application.birthRecords.adoptionStatus,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(moduleState).application.birthRecords.adoptionStatus) = $event))
                          }, null, 8, ["options", "modelValue"]),
                          (_unref(moduleState).application.birthRecords.adoptionStatus == _unref(ProfileTypes).YesNoUnknown.Yes)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "Your Full Name After Adoption",
                                      modelValue: _unref(moduleState).application.birthRecords.adoptedName,
                                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(moduleState).application.birthRecords.adoptedName) = $event)),
                                      trimmed: "",
                                      autoFocus: ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Adopted Mother's Full Name",
                                      modelValue: _unref(moduleState).application.birthRecords.adoptedMotherName,
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(moduleState).application.birthRecords.adoptedMotherName) = $event)),
                                      trimmed: ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Adopted Father's Full Name",
                                      modelValue: _unref(moduleState).application.birthRecords.adoptedFatherName,
                                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(moduleState).application.birthRecords.adoptedFatherName) = $event)),
                                      trimmed: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_FormRadioGroupField, {
                                  label: "Do you want a birth certificate with your name prior to adoption (birth name), or after adoption? *",
                                  options: _unref(ProfileTypes).AdoptionRequestType,
                                  excludedOptions: [_unref(ProfileTypes).AdoptionRequestType['N/A']],
                                  modelValue: _unref(moduleState).application.birthRecords.adoptionRequestType,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(moduleState).application.birthRecords.adoptionRequestType) = $event))
                                }, null, 8, ["options", "excludedOptions", "modelValue"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'siblings')
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    (_unref(moduleState).application.birthRecords)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createVNode(ListEditor, {
                            class: "mt-3",
                            header: "Enter The Names Of Your Siblings *",
                            items: _unref(moduleState).application.birthRecords.siblings,
                            itemIcon: "fa-user",
                            itemLabel: (sibling)=>sibling.name,
                            addLabel: "Add Sibling",
                            onAdd: ()=>siblings.value.add(),
                            onEdit: (idx)=>siblings.value.edit(idx),
                            onRemove: (idx)=>siblings.value.remove(idx)
                          }, null, 8, ["items", "itemLabel", "onAdd", "onEdit", "onRemove"]),
                          (siblings.value.activeItem)
                            ? (_openBlock(), _createBlock(_component_ModalDialog, {
                                key: 0,
                                active: "",
                                title: "Sibling",
                                severity: "link",
                                firstButtonText: "Cancel",
                                firstButtonSeverity: "danger",
                                onFirstbuttonselected: _cache[36] || (_cache[36] = ($event: any) => (siblings.value.activeItem = null)),
                                secondButtonText: "Save",
                                secondButtonSeverity: "link",
                                onSecondbuttonselected: _cache[37] || (_cache[37] = ($event: any) => (siblings.value.onEditComplete()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Columns, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormTextField, {
                                        label: "Full Name *",
                                        modelValue: siblings.value.activeItem.name,
                                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((siblings.value.activeItem.name) = $event)),
                                        trimmed: "",
                                        autoFocus: ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Columns, { style: {"margin-bottom":"12rem"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormDateField, {
                                        label: "Date Of Birth *",
                                        modelValue: siblings.value.activeItem.dateOfBirth,
                                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((siblings.value.activeItem.dateOfBirth) = $event)),
                                        past: ""
                                      }, null, 8, ["modelValue"]),
                                      _createElementVNode("div", _hoisted_38, [
                                        (siblings.value.activeItem.dateOfBirth)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                                              _hoisted_40,
                                              _createElementVNode("strong", null, _toDisplayString(_unref(formatAge)(siblings.value.activeItem.dateOfBirth)), 1),
                                              _hoisted_41
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  (siblings.value.errors.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(siblings.value.errors, (error) => {
                                          return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
                                        }), 128))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_43))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'mailing')
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _hoisted_45,
                    (_unref(moduleState).application.socialSecurity)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createVNode(_component_FormCheckboxField, {
                            boxLabel: `I have no fixed address - use ${_unref(sessionState).session!.user.assignedCareProvider!.name} address instead`,
                            modelValue: _unref(moduleState).application.socialSecurity.useCareProviderAddressForMailing,
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_unref(moduleState).application.socialSecurity.useCareProviderAddressForMailing) = $event))
                          }, null, 8, ["boxLabel", "modelValue"]),
                          (!_unref(moduleState).application.socialSecurity.useCareProviderAddressForMailing)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "Building Number / Name *",
                                      modelValue: _unref(moduleState).application.socialSecurity.mailingAddress!.number,
                                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_unref(moduleState).application.socialSecurity.mailingAddress!.number) = $event)),
                                      autoFocus: ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Street *",
                                      modelValue: _unref(moduleState).application.socialSecurity.mailingAddress!.street,
                                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_unref(moduleState).application.socialSecurity.mailingAddress!.street) = $event)),
                                      trimmed: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "City *",
                                      modelValue: _unref(moduleState).application.socialSecurity.mailingAddress!.city,
                                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_unref(moduleState).application.socialSecurity.mailingAddress!.city) = $event)),
                                      trimmed: ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Zip Code *",
                                      modelValue: _unref(moduleState).application.socialSecurity.mailingAddress!.postalCode,
                                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_unref(moduleState).application.socialSecurity.mailingAddress!.postalCode) = $event)),
                                      numeric: "",
                                      length: 9
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_FormSelectField, {
                                      label: "State *",
                                      options: _unref(ProfileTypes).StateNotUnknown,
                                      allowNullSelection: "",
                                      modelValue: _unref(moduleState).application.socialSecurity.mailingAddress!.state,
                                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_unref(moduleState).application.socialSecurity.mailingAddress!.state) = $event))
                                    }, null, 8, ["options", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'idType')
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _hoisted_49,
                    _hoisted_50,
                    _hoisted_51,
                    _hoisted_52,
                    _hoisted_53,
                    _hoisted_54,
                    _hoisted_55,
                    _hoisted_56,
                    _hoisted_57,
                    _createVNode(_component_FormRadioGroupField, {
                      label: "Which type of ID do you have?",
                      options: _unref(IdTypeOptions),
                      modelValue: _unref(moduleState).miscState.idType.possessedIdType,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_unref(moduleState).miscState.idType.possessedIdType) = $event)),
                      stacked: ""
                    }, null, 8, ["options", "modelValue"]),
                    (_unref(moduleState).miscState.idType.possessedIdType == 'NONE')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_62))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'supportDocUpload')
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _hoisted_64,
                    _hoisted_65,
                    _hoisted_66,
                    _hoisted_67,
                    _hoisted_68,
                    _createVNode(_component_DocumentUploadWidget, {
                      documents: _unref(moduleState).supportDocuments,
                      onUpload: _cache[45] || (_cache[45] = ($event: any) => (uploadSupportDocument($event))),
                      onDelete: _cache[46] || (_cache[46] = ($event: any) => (deleteSupportDocument($event)))
                    }, null, 8, ["documents"]),
                    (_unref(moduleState).formNavState.errors.length == 0 && _unref(moduleState).miscState.idType.possessedIdType == _unref(IdTypeOptions)['Secondary ID'] && _unref(moduleState).supportDocuments.length < 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, _hoisted_71))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'votingIntent')
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    _hoisted_73,
                    (_unref(moduleState).application.birthRecords)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          _createVNode(_component_FormRadioGroupField, {
                            label: "Do you intend to use your ID to vote? *",
                            options: _unref(YesNo),
                            modelValue: _unref(moduleState).application.birthRecords.votingIntent,
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_unref(moduleState).application.birthRecords.votingIntent) = $event))
                          }, null, 8, ["options", "modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'equifaxConsent')
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    _hoisted_76,
                    _hoisted_77,
                    _hoisted_78,
                    _hoisted_79,
                    _hoisted_80,
                    _hoisted_81,
                    _hoisted_82,
                    _createVNode(_component_FormRadioGroupField, {
                      class: "mt-3",
                      label: "Do you agree to us verifying your identity? *",
                      options: _unref(EquifaxConsentOptions),
                      modelValue: _unref(moduleState).miscState.equifaxConsent.consent,
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_unref(moduleState).miscState.equifaxConsent.consent) = $event))
                    }, null, 8, ["options", "modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'notificationPreferences')
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                    _hoisted_84,
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: "By Email",
                      modelValue: _unref(moduleState).miscState.notificationPreferences.emailEnabled,
                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_unref(moduleState).miscState.notificationPreferences.emailEnabled) = $event)),
                      isDisabled: _unref(moduleState).miscState.notificationPreferences.noneEnabled
                    }, null, 8, ["modelValue", "isDisabled"]),
                    (_unref(moduleState).miscState.notificationPreferences.emailEnabled && !_unref(moduleState).miscState.notificationPreferences.noneEnabled)
                      ? (_openBlock(), _createBlock(_component_HalfColumn, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FormTextField, {
                              label: "Email Address",
                              modelValue: _unref(moduleState).notificationPreferences.email,
                              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_unref(moduleState).notificationPreferences.email) = $event)),
                              trimmed: "",
                              autoFocus: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: "By SMS",
                      modelValue: _unref(moduleState).miscState.notificationPreferences.smsEnabled,
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_unref(moduleState).miscState.notificationPreferences.smsEnabled) = $event)),
                      isDisabled: _unref(moduleState).miscState.notificationPreferences.noneEnabled
                    }, null, 8, ["modelValue", "isDisabled"]),
                    (_unref(moduleState).miscState.notificationPreferences.smsEnabled && !_unref(moduleState).miscState.notificationPreferences.noneEnabled)
                      ? (_openBlock(), _createBlock(_component_HalfColumn, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FormTextField, {
                              label: "Phone Number",
                              modelValue: _unref(moduleState).notificationPreferences.sms,
                              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_unref(moduleState).notificationPreferences.sms) = $event)),
                              trimmed: "",
                              autoFocus: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: "Do not contact me",
                      modelValue: _unref(moduleState).miscState.notificationPreferences.noneEnabled,
                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_unref(moduleState).miscState.notificationPreferences.noneEnabled) = $event))
                    }, null, 8, ["modelValue"]),
                    (_unref(moduleState).miscState.notificationPreferences.noneEnabled)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_85, _hoisted_87))
                      : _createCommentVNode("", true)
                  ]))
                : (form.value.state.activePage == 'preSubmit')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                      _hoisted_89,
                      _createElementVNode("div", _hoisted_90, [
                        (submissionInProgress.value)
                          ? (_openBlock(), _createBlock(LoadingSpinner, {
                              key: 0,
                              class: "mt-4"
                            }))
                          : (_openBlock(), _createBlock(_component_SaveButton, {
                              key: 1,
                              large: "",
                              label: "Submit!",
                              icon: "fa-paper-plane",
                              onClick: _cache[54] || (_cache[54] = ($event: any) => (submitApplication()))
                            }))
                      ])
                    ]))
                  : (form.value.state.activePage == 'completed')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                        _hoisted_92,
                        _hoisted_93,
                        (_unref(moduleState)!.miscState.completed.notarizationRequired)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_94, _hoisted_97))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_98, [
                          _createVNode(_component_SaveButton, {
                            large: "",
                            label: "Return To Home Page",
                            onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.$router.push('/')))
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
              (form.value!.state.errors.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.state.errors, (error) => {
                      return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!submissionInProgress.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                    (form.value.canNavigateBack())
                      ? (_openBlock(), _createBlock(_component_SaveButton, {
                          key: 0,
                          large: "",
                          label: "Back",
                          icon: "fa-chevron-left",
                          onClick: _cache[56] || (_cache[56] = ($event: any) => (form.value.navigateBack()))
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_101,
                    (form.value.canNavigateForward())
                      ? (_openBlock(), _createBlock(_component_SaveButton, {
                          key: 1,
                          large: "",
                          label: "Next",
                          icon: "fa-chevron-right",
                          iconRight: "",
                          onClick: _cache[57] || (_cache[57] = ($event: any) => (form.value.navigateForward()))
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
    ]),
    _: 1
  }))
}
}

})